import api from '../axios';

export const fetchBlogs = async (params = {}) => {
    const response = await api.get('/blogs', { params });
    return response.data;
};

export const fetchBlogBySlug = async (slug) => {
    const response = await api.get(`/blogs/${slug}`);
    return response.data;
};

export const fetchBlogCategories = async () => {
    const response = await api.get('/blogs/categories');
    return response.data;
};
